export function obterMensagensErro(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    const err = error as any;

    const data = err.response?.data;

    // 1) Backend Node, error-handler global: { statusCode, error, message }.
    //    Aqui `error` é RÓTULO, não mensagem — vem de `error.name`, e o driver
    //    pg nomeia os erros dele de "error". Era exatamente isso que fazia o
    //    toast dizer "error" e esconder a causa real, que está em `message`.
    if (data?.statusCode != null) {
      const detalhes = Array.isArray(data.details)
        ? data.details.map((d: any) => d.message ?? d.msg).filter(Boolean).join(' | ')
        : '';
      const base = typeof data.message === 'string' ? data.message : String(data.error ?? '');
      return detalhes ? `${base}: ${detalhes}` : base;
    }

    // 2) Rotas que respondem { error: "mensagem" } direto, sem statusCode no
    //    corpo — é o padrão do Processo Eletrônico. Sem isto, todo 4xx virava
    //    "Request failed with status code 409".
    if (typeof data?.error === 'string') {
      return data.error;
    }

    // 2) FastAPI array de erros
    if (Array.isArray(data?.detail)) {
      return data.detail.map((d: any) => d.msg).join(' | ');
    }

    // 3) FastAPI/Axios string
    if (typeof data?.detail === 'string') {
      return data.detail;
    }

    if (typeof data?.message === 'string') {
      return data.message;
    }

    // 3) FastAPI direto
    if (typeof err.detail === 'string') {
      return err.detail;
    }

    // 4) Erro JS nativo
    if (typeof err.message === 'string') {
      return err.message;
    }
  }

  if (typeof error === 'string') return error;

  try {
    return `Erro desconhecido: ${JSON.stringify(error)}`;
  } catch {
    return 'Erro desconhecido';
  }
}
